import { render, staticRenderFns } from "./regist_ps2hs.vue?vue&type=template&id=4fae183b&scoped=true&"
import script from "./regist_ps2hs.vue?vue&type=script&lang=js&"
export * from "./regist_ps2hs.vue?vue&type=script&lang=js&"
import style0 from "./regist_ps2hs.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./regist_ps2hs.vue?vue&type=style&index=1&id=4fae183b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fae183b",
  null
  
)

export default component.exports